import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { DashboardService } from '../dashboard.service';
import { DataService } from 'src/app/services/data.service';

@Component({
  selector: 'app-subscription-success',
  templateUrl: './subscription-success.component.html',
  styleUrls: ['./subscription-success.component.scss']
})

export class SubscriptionSuccessComponent implements OnInit {

  constructor(private router: Router, private dashboardService: DashboardService, private dataService: DataService) { }

  ngOnInit(): void {
    // Refresh profile to reflect updated payment status immediately
    try {
      this.dashboardService.getAdminProfile().subscribe((res: any) => {
        try {
          const prevData = JSON.parse(localStorage.getItem('currentUser') || '{}');
          prevData.paymentStatus = res?.paymentStatus;
          localStorage.setItem('currentUser', JSON.stringify(prevData));
        } catch { }
        try { this.dataService.cancelSubscriptionClicked('Subscription Active'); } catch { }
      });
    } catch { }
  }

  gotoSettings(): void {
    this.router.navigate(['dashboard/settings']);
  }

  createAssessment(): void {
    this.router.navigate(['dashboard/assessments/create']);
  }

  openEmailClient(): void {
    // Ensure the mailto link opens properly
    window.location.href = 'mailto:support@evaltrix.com';
  }

}
